<!-- While a tester's clock override is on (the /test page; useServerClock isOverridden), a small
     button in the corner shows the pretend time and turns test mode off: the override silently
     moved the banner's countdown before (2026-10-14). Only the tester's own session ever has one. -->
<template>
  <button
    v-if="isOverridden"
    type="button"
    class="testClockOff"
    :aria-label="`Test clock set to ${shownTime}. Disable test mode`"
    @click="disable">
    Test clock: {{ shownTime }} · <span class="action">Disable</span>
  </button>
</template>

<script setup>
import {computed, onBeforeUnmount, ref, watch} from "vue";
import useServerClock, {clearClockOverride} from "@/composables/useServerClock";

const {getServerNow, isOverridden, offsetMs} = useServerClock();
const now = ref(getServerNow());
const tick = setInterval(() => (now.value = getServerNow()), 30000);
onBeforeUnmount(() => clearInterval(tick));
// the server's answer (or a new override) moves the clock at once
watch([isOverridden, offsetMs], () => (now.value = getServerNow()));

// "4 Nov, 09:15" in the viewer's own clock
const shownTime = computed(() => now.value.toFormat("d LLL, HH:mm"));

async function disable() {
  await clearClockOverride();
  now.value = getServerNow();
}
</script>

<style scoped>
.testClockOff {
  position: fixed;
  left: 12px;
  top: calc(var(--cta-height, 70px) + 8px); /* under the call-to-action banner, clear of the
                                               bottom's cookie and test-site banners */
  z-index: 50;
  font-size: 0.8rem;
  padding: 0.3em 0.7em;
  color: #1c1c1c;
  background: #ffd36e; /* a warning yellow: test mode, easy to notice */
  border: 1px solid #c79a2a;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.testClockOff:focus-visible {
  outline: 2px solid #1c1c1c;
  outline-offset: 2px;
}
.action {
  text-decoration: underline;
  font-weight: 600;
}
</style>
